import React from "react";
import { useSelector } from "react-redux";
import Button from "../../../../component/button/Button";
import useClientConfig from "../../../../config/careers/clientConfig";

const OptionFiveNoJob = (props: any) => {
    const questionId = useSelector((state: any) => state?.careers?.getQuestionId);
    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const noJobLang = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const noJobLangLabels = noJobLang?.noJobsSection?.[0];
    const { clientAssetsLink } = useClientConfig();
    const { navigateToJob, navigateToJobAlerts } = props;

    const showInterest = questionId?.status === 200;
    const showJobAlerts = cliendConfig?.data?.data?.clientSettings?.showJobAlertButton === 1;

    if (!showInterest && !showJobAlerts) {
        return null;
    }

    return (
        <section className="option5-nojob">
            <h3>{noJobLangLabels?.noJobs || "No current job openings"}</h3>
            <p dangerouslySetInnerHTML={{ __html: noJobLangLabels?.noJobsText || "" }} />
            <div className="option5-nojob-actions">
                {showInterest ? (
                    <Button
                        clasName="btn option5-ghost-btn"
                        label={cliendConfig?.data?.data?.clientSettings?.registerYourInterestButtonText || noJobLangLabels?.registerYourInterest}
                        iconImg={clientAssetsLink + "/Register.svg"}
                        onClick={navigateToJob}
                    />
                ) : (
                    ""
                )}
                {showJobAlerts ? (
                    <Button
                        clasName="btn option5-primary-btn"
                        label={cliendConfig?.data?.data?.clientSettings?.jobAlertButtonText || noJobLangLabels?.jobAlerts}
                        iconImg={clientAssetsLink + "/Alert.svg"}
                        onClick={navigateToJobAlerts}
                    />
                ) : (
                    ""
                )}
            </div>
        </section>
    );
};

export default OptionFiveNoJob;
